<template>
  <div>
    <div class="task-header row mb-4 py-3 align-items-center rounded shadow-sm">
      <div class="col-md-6 d-flex align-items-center">
        <h1 class="my-0"><i class="fas fa-tasks me-2 text-primary"></i> Task List</h1>
      </div>
      <div class="col-md-6 text-end">
        <button class="btn btn-create btn-lg">
          <i class="fas fa-plus me-2"></i> Create Task
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <!-- Loading Spinner -->
      <div v-if="loading" class="text-center my-5">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <!-- Bootstrap DataTable -->
      
        <table v-if="!loading" id="dataTable" class="table table-striped table-hover">
          <thead>
            <tr>
              <th>ID</th>
              <th>Task</th>
              <th>Project Name</th>
              <th>Assigned To</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
              <th>Created By</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="task in tasks" :key="task.id">
              <td>{{ task.id }}</td>
              <td>{{ truncate(task.title, 25) }}</td>
              <td>{{ task.projectName }}</td>
              <td>{{ task.assignedto }}</td>
              <td>{{ formatDate(task.startDate) }}</td>
              <td>{{ formatDate(task.endDate) }}</td>
              <td>
              <div class="d-flex align-items-center">
                  <span
                    :class="{
                      'bg-success text-white px-2 py-1 rounded': task.status === 'Open',
                      'bg-danger text-white px-2 py-1 rounded': task.status === 'Closed',
                      'bg-warning text-dark px-2 py-1 rounded': task.status === 'Inprogress'
                    }"
                    style="display: inline-block;"
                  >
                    {{ task.status }}
                  </span>
                </div>
              </td>
              <td>{{ task.created_by }}</td>
              <td class="text-center align-middle">
                <a @click="viewTask(task)" style="cursor: pointer;">
                  <i class="fas fa-eye"></i>
                </a>
              </td>

            </tr>
          </tbody>
        </table>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import apiClient from '../../Services/axiosConfig';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import dayjs from 'dayjs';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';
export default {
  name: 'TaskPage',
  setup() {
    const tasks = ref([]);
    const loading = ref(false);
    const store = useStore();
    const router = useRouter();

    const fetchTasks = async () => {
      loading.value = true;

      // Check if tasks are cached in Vuex
      if (store.state.tasks && store.state.tasks.length > 0) {
        tasks.value = store.state.tasks;
        loading.value = false;
        initializeDataTable();
        return;
      }

      try {
        const response = await apiClient.get('mytasks_v2');
        tasks.value = response.data.data;
        store.commit('setTasks', response.data.data);
      } catch (error) {
        console.error('Failed to fetch tasks:', error);
      } finally {
        loading.value = false;
        initializeDataTable();
      }
    };

    const initializeDataTable = () => {
      $(document).ready(() => {
        $('#dataTable').DataTable({
          destroy: true,
          responsive: true,
          searching: true,
          pageLength: 10,
          language: { search: "Search:" },
          searchDelay: 500,
        });
      });
    };

    const viewTask = (task) => {
      store.commit('setTaskDetails', task);
      router.push({ name: 'ViewTask', params: { id: task.id } });
    };

    const formatDate = (dateString) => {
      return dayjs(dateString).format('DD-MMM-YYYY HH:mm');
    };

    const truncate = (text, length) => {
      return text.length > length ? text.substring(0, length) + '...' : text;
    };

    onMounted(() => {
      fetchTasks();
    });

    return {
      tasks,
      loading,
      viewTask,
      formatDate,
      truncate,
    };
  },
};

</script>

<style scoped>
.spinner-border {
  width: 3rem;
  height: 3rem;
}

table tbody tr:hover {
  background-color: #f1f1f1;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #004085;
}
</style>
